export default "__VITE_ASSET__CbY50cGy__"